var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgPass = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12H15.5V15H6.5V12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8011 6.82528L22.7955 5.83092L19.6314 2.66686L18.6371 3.66122L19.7219 4.74609L18.9584 5.50955L17.6677 4.21875H15.9702V3.09375C15.9702 1.38783 14.5824 0 12.8765 0C12.6284 0 1.55001 0 1.20459 0V24H20.8921V7.44314L19.9529 6.50391L20.7163 5.74045L21.8011 6.82528ZM12.8765 1.40625C13.807 1.40625 14.564 2.16323 14.564 3.09375V4.21875H12.7458L9.93332 1.40625H12.8765ZM19.4858 22.5938H2.61084V1.40625H7.9446L12.1634 5.625H17.0852L19.4858 8.02561V22.5938Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPass, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pass.be85a01e.svg";
export { ForwardRef as ReactComponent };